
import { useState } from 'react';
import type { GenerateCopyResult } from '../../../types';

interface UseUnifiedCopyViewProps {
    result: GenerateCopyResult;
}

export const useUnifiedCopyView = ({ result }: UseUnifiedCopyViewProps) => {
    const [activeSite, setActiveSite] = useState<string>('US');

    const availableSites = Object.keys(result.titles).filter(site => result.titles[site]);
    const bulletPoints = result.bullet_points[activeSite] || [];
    const coverage = result.keyword_coverage[activeSite];

    // 复制到剪贴板
    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
    };

    return {
        activeSite,
        setActiveSite,
        availableSites,
        bulletPoints,
        coverage,
        copyToClipboard,
    };
};
